Booking = {

    post: '',

    FormValidation: function () {

        // http://jqueryvalidation.org/validate/
        //console.log(this);

        var self = this,
            url = '/enter',
            form = $('#booking_form'),
            msg_place = $('.js_msg', form),
            additional_form_data;

        validator = form.validate({
            //debug: true, // also prevents submit!

            // input el classes
            //errorClass: "invalid_input_el",
            //validClass : "valid_input_el",

            // error label
            // The problem is that you cannot remove success class after it's there!!!! There is no 'error' handler function
            //success: "valid_label_el", // class for the error msg el if input is valid
            //errorElement: "div", // a bug: error class is not removed
            //success: function(label) {
            //  console.log('success func is called!');
            //  label.addClass("valid_label_el").text("Ok!");
            //},

            rules: {

                guests_count: {
                    required: true
                },

                date: {
                    required: true
                },

                time: {
                    required: true
                },

                name: {
                    required: true
                    , minlength: 3
                },

                phone: {
                    required: true
                },

                email: {
                    required: true
                    , email: true
                }

            },

            messages: {
                guests_count: {
                    required: "Раскройте секрет, сколько Вас будет?"
                },
                name: {
                    required: "И все же, как мы можем к Вам обращаться?"
                },
                date: {
                    required: "Пожалуйста, укажите дату!"
                },
                time: {
                    required: "А как же время?"
                },
                phone: {
                    required: "Без телефона мы не сможем подтвердить Ваш столик!"
                },
                email: {
                    required: "Нам необходим Ваш Email! Никакого спама, обещаем!"
                }

            },


            /**
             *
             * this handler is passes the form element
             */
            submitHandler: function (form) {
                //console.log('submitHandler');
                //return false;

                // цель яндекс метрики при отправке формы после валидации
                //yaCounter20843002.reachGoal('METRIKA_GOAL_BOOKING_CLICK');

                $(form).attr('action', Booking.post); // defense against unwanted automated submits

                //return false; // prevent form submit
                form.submit(); // submit the form

                //self.sendFormDataToServer(url, form, additional_form_data, msg_place, form);

            }

        });

    }

}


